// import firebase from "firebase/compat/app";
// import 'firebase/compat/firestore';
// import 'firebase/compat/storage'
// import 'firebase/compat/auth'
// const firebaseApp = firebase.initializeApp({
//   apiKey: "AIzaSyAQZ5mCVUucMiQ5XaK9q9Jktn",
//   authDomain: "eat4living-3f595.firebaseapp.com",
//   databaseURL: "",
//   projectId: "eat4living-3f595",
//   storageBucket: "gs://eat4living-3f595.appspot.com",
//   messagingSenderId: "992907783526"
// })
// const db1 = firebaseApp.firestore()
// export const storage1 = firebase.storage()
// export const auth1 = firebase.auth()
// export default db1

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";

const firebaseConfig1 = {
  apiKey: "AIzaSyAQZ5mCVUucMiQ5XaK9q9Jktn",
  authDomain: "eat4living-3f595.firebaseapp.com",
  projectId: "eat4living-3f595",
  storageBucket: "gs://eat4living-3f595.appspot.com",
  messagingSenderId: "992907783526"
};

export const app1 = firebase.initializeApp(firebaseConfig1, "app1");

export const db1 = app1.firestore();
export const storage1 = app1.storage();
export const auth1 = app1.auth();